export const checkJson = (json: string) => new Promise<boolean>((resolve) => {
  try {
    JSON.parse(json);
    resolve(true);
  } catch(e) {
    resolve(false);
  }
});